define(function ( require ) {
    'use strict';

    var Marionette = require('marionette');

    var MissedCallsCollection = require('collections/missed_calls');

    var Model = require('models/missed_calls_model');

    var Calls = require('parts/calls/calls');
    var MissedCalls = require('parts/calls/missedCalls');

    var MainTpl = require('text!tmpls/parts/caller/main.tpl').default;

    return Marionette.LayoutView.extend({
        template: MainTpl,

        ui: {
            'openCalls': '.js-tab-call',
            'openMissedCalls': '.js-tab-missed-call',
            'tab': '.js-tab'
        },

        events: {
            'click @ui.openCalls': 'openCalls',
            'click @ui.openMissedCalls': 'openMissedCalls',
            'click @ui.tab': 'addActive'
        },

        regions: {
            regionMain: '.js-region-main'
        },


        onRender: function () {
            this.openCalls();
        },


        openCalls: function () {
            this.showChildView('regionMain', new Calls());
        },

        openMissedCalls: function () {
            var that = this;
            var missedModel = new Model();
            var missedCallsCollection = new MissedCallsCollection();
            var getData = function () {
                missedModel.fetch()
                    .fail(function () {
                        console.log('MissedModel model collection error');
                    })
                    .done(function () {
                        that.showChildView('regionMain',
                            new MissedCalls(
                                {model: missedModel, collection: missedCallsCollection}
                            )
                        );
                    });
            };
            missedCallsCollection
                .fetch()
                .fail(function () {
                    console.log('missedCallsCollection collection error');
                })
                .done(function () {
                    getData();
                });
        },

        addActive: function ( e ) {
            this.ui.tab.removeClass('active');
            $(e.currentTarget).addClass('active');
        }
    });
});
